export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      experience: "Experience",
      contact: "Contact"
    },
    home: {
      title: "Ellinor Kantedal",
      subtitle: "Psychologist & Consultant",
      tagline: "Swedish licensed psychologist based in Barcelona, offering evidence-based therapy and consultation for Swedish clients.",
      contactMe: "Contact Me",
      learnMore: "Learn More"
    },
    about: {
      title: "About Me",
      description: "I'm Ellinor, a Swedish licensed psychologist currently living in Barcelona, where I work as a consultant specializing in psychological treatment towards Swedish clients.",
      expertise: "My Expertise",
      expertiseDescription: "I have extensive experience in neuropsychological problems and neurodiversity, helping individuals understand and navigate their unique cognitive profiles. My therapeutic approach integrates evidence-based methods including CBT, relational therapy, and mentalization-based therapy to create personalized treatment plans that foster meaningful change.",
      swedishLicensed: "Swedish Licensed",
      psychologyProfessional: "Psychology Professional",
      neuropsychology: "Neuropsychology",
      neuropsychologyExperience: "Experienced in Neuropsychology and neurodiversity"
    },
    services: {
      title: "My Experience",
      subtitle: "Professional background in clinical and neuropsychology",
      current: "Current",
      psychologyConsultant: "Psychology Consultant",
      psychologyConsultantDescription: "Psychological CBT treatment and consultation services for clients requiring evidence-based therapeutic interventions.",
      clinicalNeuropsychologist: "Clinical/Neuropsychologist",
      clinicalNeuropsychologistWorkplace: "Sahlgrenska University Hospital, Gothenburg",
      clinicalNeuropsychologistDescription: "Neuropsychological testing and cognitive assessment of children and adolescents with congenital or acquired brain injury.",
      schoolPsychologist: "School Psychologist",
      schoolPsychologistWorkplace: "Ekkälleskolan and Elsa Brändström School",
      schoolPsychologistDescription: "Cognitive assessment and preventive interventions for student health. Educated school staff in positive behavior support approaches.",
      clinicalPsychologist: "Clinical Psychologist",
      clinicalPsychologistWorkplace: "Psychiatric Clinic, Linköping",
      clinicalPsychologistDescription: "Conducted psychotherapy and treatment of adults with mental health issues using evidence-based therapeutic approaches.",
      psychologyIntern: "Psychology Intern",
      psychologyInternWorkplace: "Refugee Medicine Center, Norrköping",
      psychologyInternDescription: "Psychological assessment and counseling with a focus on trauma processing for refugees and asylum seekers."
    },
    contact: {
      title: "Contact Me",
      subtitle: "Feel free to reach out with questions or to book a first session.",
      email: "Email",
      spain: "Spain",
      sweden: "Sweden"
    }
  },
  sv: {
    nav: {
      home: "Hem",
      about: "Om mig",
      experience: "Erfarenhet",
      contact: "Kontakt"
    },
    home: {
      title: "Ellinor Kantedal",
      subtitle: "Psykolog & Konsult",
      tagline: "Legitimerad psykolog baserad i Barcelona. Jag erbjuder evidensbaserad terapi och konsultation för svenska klienter.",
      contactMe: "Kontakta mig",
      learnMore: "Läs mer"
    },
    about: {
      title: "Om mig",
      description: "Jag är Ellinor, en legitimerad psykolog som för närvarande bor i Barcelona, där jag arbetar som konsult specialiserad på psykologisk behandling för svenska klienter.",
      expertise: "Min expertis",
      expertiseDescription: "Jag har omfattande erfarenhet av neuropsykologiska problem och neurodiversitet, och hjälper individer att förstå och navigera sina unika kognitiva profiler. Min terapeutiska approach integrerar evidensbaserade metoder inklusive KBT, relationell terapi och mentaliseringsbaserad terapi för att skapa personliga behandlingsplaner som främjar meningsfull förändring.",
      swedishLicensed: "Psykolog",
      psychologyProfessional: "Legitimerad i Sverige",
      neuropsychology: "Neuropsykologi",
      neuropsychologyExperience: "Erfaren inom neuropsykologi och neurodiversitet"
    },
    services: {
      title: "Min erfarenhet",
      subtitle: "Professionell bakgrund inom klinisk och neuropsykologi",
      current: "Nuvarande",
      psychologyConsultant: "Psykologkonsult",
      psychologyConsultantDescription: "Psykologisk KBT-behandling och konsulttjänster för klienter som kräver evidensbaserade terapeutiska interventioner.",
      clinicalNeuropsychologist: "Klinisk/Neuropsykolog",
      clinicalNeuropsychologistWorkplace: "Sahlgrenska Universitetssjukhuset, Göteborg",
      clinicalNeuropsychologistDescription: "Neuropsykologisk testning och kognitiv bedömning av barn och ungdomar med medfödd eller förvärvad hjärnskada.",
      schoolPsychologist: "Skolpsykolog",
      schoolPsychologistWorkplace: "Ekkälleskolan och Elsa Brändström Skola",
      schoolPsychologistDescription: "Kognitiv bedömning och förebyggande interventioner för elevhälsa. Utbildade skolpersonal i positiva beteendestödjande metoder.",
      clinicalPsychologist: "Klinisk psykolog",
      clinicalPsychologistWorkplace: "Psykiatriska kliniken, Linköping",
      clinicalPsychologistDescription: "Genomförde psykoterapi och behandling av vuxna med psykiska hälsoproblem med evidensbaserade terapeutiska metoder.",
      psychologyIntern: "Psykologpraktikant",
      psychologyInternWorkplace: "Flyktingmedicincentrum, Norrköping",
      psychologyInternDescription: "Psykologisk bedömning och rådgivning med fokus på traumabearbetning för flyktingar och asylsökande."
    },
    contact: {
      title: "Kontakta mig",
      subtitle: "Hör gärna av dig med frågor eller för att boka ett första samtal.",
      email: "E-post",
      spain: "Spanien",
      sweden: "Sverige"
    }
  }
};

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en;